import { sendSortListingsEvent } from '../../utils/event-triggers';
import { invalidTypes } from './config';

class {
  onCreate() {
    this.state = {
      menu: null
    }
  }
  onMount() {
    this.state.menu = this.getComponent("menu");
  }
  onInput(input) {
    this.tabName = input.tabName;
    this.entries = input.entries;
  }
  onChange(event) {
    const entry = this.entries?.[event?.index];
    this.state.menu._expander.expanded = false;
    const action = entry?.action;
    const tracking = action?.trackingList;
    const targetUrl = action?.URL;
    if(tracking) {
      document.dispatchEvent(new CustomEvent('pulsar', { detail: tracking }));
    }
    if(targetUrl) {
      sendSortListingsEvent({
        url: targetUrl,
        tabName: this.tabName
      });
    }
  }
}

$ {
  const entries = input?.entries || [];
  const validEntries = entries?.filter( entry => !invalidTypes.includes(entry?._type) );
  const selectedEntries = validEntries?.filter( entry => entry.selected );
  const selectedLabel = selectedEntries.map( entry => entry?.label?.textSpans?.[0]?.text || "" ).join( ", ");
  const label = `${input?.label?.textSpans?.[0]?.text || ""} ${selectedLabel}`;
  const selectionType = (input?.selectionType === "SINGLE")? "radio" : "checkbox";
  const hasSingleSelection = selectedEntries?.length == 1 && selectedEntries[0]?.defaultChoice !== true;
  const hasMultipleSelections = selectedEntries.length > 1;
  const selectedStyle = (hasSingleSelection || hasMultipleSelections) ? "selected" : "";
}

<if(validEntries?.length > 0 )>
  <ebay-filter-menu-button key="menu" text=label onChange("onChange") type=selectionType class=selectedStyle>
    <for|entry| of=validEntries>
      <@item value=(entry?.paramValue || "") checked=entry?.selected disabled=(entry?.disabled === true)>${entry?.label?.textSpans?.[0]?.text}</@item>
    </for>
  </ebay-filter-menu-button>
</if>
